import { render } from "./JarvisKnowledgeView.vue?vue&type=template&id=7932ab96&scoped=true"
import script from "./JarvisKnowledgeView.vue?vue&type=script&lang=js"
export * from "./JarvisKnowledgeView.vue?vue&type=script&lang=js"

import "./JarvisKnowledgeView.vue?vue&type=style&index=0&id=7932ab96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7932ab96"]])

export default __exports__